import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ButtonConfig } from '@zipari/shared-ds-util-button';
import { LinkConfig } from '@zipari/shared-ds-util-navigation';
import { ExternalSiteModalConfig } from '../../chords/external-site-warning-modal/external-site-warning-modal.model';
import { fadeToMaskOpacity } from '../../shared/animations/fade';
import { ActionItemConfig } from '../action-button/action-button.constants';
import { checkInputsForText } from '../../design-system.helper';

@Component({
  selector: 'mobile-actions-modal',
  templateUrl: './mobile-actions-modal.component.html',
  styleUrls: ['./mobile-actions-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeToMaskOpacity],
})
export class MobileActionsModalComponent implements OnInit {
  @Input() actions: ActionItemConfig[] = [];

  @Input() externalSiteModalConfig: ExternalSiteModalConfig;

  @Input() isActive = false;

  @Output() actionLinkClicked = new EventEmitter<LinkConfig>();

  @Output() isActiveChange = new EventEmitter<boolean>();

  ngOnInit(): void {
    const [actions, externalSiteModalConfig] = checkInputsForText([
      this.actions,
      this.externalSiteModalConfig,
    ]);

    this.actions = actions as ActionItemConfig[];
    this.externalSiteModalConfig =
      externalSiteModalConfig as ExternalSiteModalConfig;
  }

  public buttonsConfig: ButtonConfig = {
    content: 'Cancel',
    size: 'fullWidth',
    level: 'medium',
  };

  public cancel(): void {
    this.isActive = false;
    this.isActiveChange.next(this.isActive);
  }

  public handleLinkClicked(link: LinkConfig) {
    this.actionLinkClicked.emit(link);
    this.cancel();
  }

  public hideBottomBorders(index: number): boolean {
    return index >= 0 && index < this.actions.length - 1;
  }

  public hideTopBorders(index: number): boolean {
    return (
      index > 0 &&
      (index < this.actions.length - 1 || index === this.actions.length - 1)
    );
  }
}
